"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchOperationSummary = void 0;
const openapi_1 = require("../../openapi");
const IErrorSummary_1 = require("./IErrorSummary");
class BatchOperationSummary {
    totalOperations;
    successfulOperations;
    errors;
    constructor() {
        this.totalOperations = 0;
        this.successfulOperations = 0;
        this.errors = [];
    }
    addError(errorSummaryCode, paramName) {
        const errorSummary = this.errors.find((error) => error.code === errorSummaryCode &&
            error.paramName === paramName);
        if (errorSummary) {
            errorSummary.count += 1;
        }
        else {
            this.errors.push({
                code: errorSummaryCode,
                paramName: paramName,
                count: 1,
            });
        }
    }
    incrementSuccessfulOperations() {
        this.successfulOperations += 1;
    }
    incrementTotalOperations() {
        this.totalOperations += 1;
    }
}
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], BatchOperationSummary.prototype, "totalOperations", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], BatchOperationSummary.prototype, "successfulOperations", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IErrorSummary_1.IErrorSummary) })
], BatchOperationSummary.prototype, "errors", void 0);
exports.BatchOperationSummary = BatchOperationSummary;
